import {httpCore} from "./instance/http";

export const postUserForm   = params => httpCore.post('callme/rest/user-form',params);

